
















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdateInfo } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import constant from '@/utils/constant'

@Component({
  components: {
    VImageUpload,
  },
})
export default class ChangeStatusMedicineCabineDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
  }
  private UserRole = constant.UserRole
  private data: any = {}
  private show = false
  
  public async open(data: any) {
    this.show = true
    this.data = data

  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    status: [this.requiredRule],
  }

  public async save() {


    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
      

        let result = {}

        result = await UpdateInfo({
          userNo: this.data.userNo,
          userRole: this.data.role
        })
       
        console.log(result)
        if(result){
          this.close()
        }
        
      } else {
        return false
      }
    })
  }
}
